import './logo.style.sass';
import template from './logo.tpl.pug';

export default {
    selector: 'dbLogo',
    template: template()
};



// WEBPACK FOOTER //
// ./src/common/component/logo/logo.cmpt.js